export default function() {
    this.loadUser()
}
